var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('CommunityComponents',{attrs:{"subunitId":_vm.subunitId,"activeTab":_vm.activeTab},on:{"tab-change":_vm.handleTabChange}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }